import React, { Component } from 'react';
import { Select } from 'antd';

const { Option } = Select;

class SelectFieldAnt extends Component {
  render() {
    const {input, label, options, className, meta: { touched, error }, inputProps, handleChange} = this.props;
    return (
      <div style={{marginBottom: 10,}} className={className}>
        {label && <label>{label}</label>}
        <Select {...input} value={input.value == 0 ? '' : input.value} {...inputProps} onChange={(e) => {
          input.onChange(e);
          if(handleChange){
            handleChange(e);
          }
        }}>
          {options.map((item, _i) => <Option key={'opt_' + input.name + _i} value={item.value}>{item.title}</Option>)}
        </Select>
        {touched && ((error && <span style={{color: '#a94442'}}>{error}</span>))}
      </div>
    );
  }
}

export default SelectFieldAnt;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/SelectFieldAnt.jsx